import { Device } from '@awesome-cordova-plugins/device/ngx';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar } from '@capacitor/status-bar';
import { environment } from '@environments/environment';
import { MenuController, ModalController, Platform } from '@ionic/angular';
import { Menu } from '@services/menu/menu';
import { SideMenuService } from '@services/menu/side-menu.service';
import { parseColor } from '@utils/color';
export class ApplicationBase {
  readonly mainMenu: Menu;

  constructor(
    protected platform: Platform,
    protected modalController: ModalController,
    protected menuService: SideMenuService,
    protected menuController: MenuController,
    protected device: Device
  ) {
    this.mainMenu = menuService.get();
    if (!environment.production) {
      (window as any).openTranslate = async () => {
        const menu = this.mainMenu.menus.find(m => m.text === 'static.translations');
        if (menu) {
          // TODO: @deprecated please use ModalFactoryService instead
          this.modalController.create({ component: menu.type }).then(m => m.present());
        }
      };
    }
    platform.ready().then(async () => {
      if (platform.is('cordova')) {
        if (this.device.platform === 'Android') {
          StatusBar.setOverlaysWebView({ overlay: false });
          StatusBar.setBackgroundColor({ color: parseColor() });
        }
        SplashScreen.hide();
      } else {
        this.setupBackButtonBehavior();
      }
    });
  }

  protected setupBackButtonBehavior() {
    window.onpopstate = () => {
      if (this.menuController.isOpen()) {
        this.menuController.close();
        return;
      }
    };
  }
}
